import { c as _c } from "react/compiler-runtime";
import { useMutation } from "@tanstack/react-query";
import getApiClient from "@/lib/api";
import { unwrap } from "@/lib/api/error";

/**
 * Start a one-time custom-amount donation. Resolves to the Mollie hosted checkout
 * URL the caller should redirect the browser to. This endpoint is public, so it
 * works for logged-out visitors too.
 */
export function useDonate() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getApiClient();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const apiClient = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mutationFn: async amountCents => {
        const data = unwrap(await apiClient.POST("/api/donation", {
          body: {
            amount_cents: amountCents
          }
        }));
        return data.checkout_url ?? undefined;
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useMutation(t1);
}